import { Route, Routes } from "react-router-dom";
import MediaPage from "../../pages/module-pages/media/MediaPage";



export default function MediaNav() {
  return (
    <Routes>
      <Route path="/" element={<MediaPage />} />
    </Routes>
  );
}
